import { FleekError } from './FleekError';

type ApplicationNameInvalidErrorOptions = {
  name: string;
};

export class ApplicationNameInvalidError extends FleekError<ApplicationNameInvalidErrorOptions> {
  public name = 'ApplicationNameInvalidError';

  toString = () => `The application name ${this.data.name} is invalid.`;
}
